export default __webpack_public_path__ + "static/media/hero-image-1.146699d3.png";